import React from "react"
import BasketPageContainer from "../../containers/checkout/basket"
import { basketPageDataQuery } from "../../contents/basket/queries"
import { fetchBasketPageData } from "../../contents/basket/fetch"
import GenericSEO from "../../features/seo/components/GenericSEO"
import { wrapPage } from "../../aggregators/page"
import { WrapPage } from "../../root"

interface Props {
  contents: any
  languageId: string
  rootData: any
}

export default function BasketPage({ rootData }: Props) {
  // const { data } = usePreviewSubscription(basketPageDataQuery, {
  //   params: { locale: languageId },
  //   initialData: contents,
  //   enabled: isPreviewSession(),
  // })
  return (
    <WrapPage rootData={rootData}>
      <BasketPageContainer />
      <GenericSEO title="Carrello" description="Il tuo carrello" noIndex />
    </WrapPage>
  )
}

export async function getStaticProps({ locale }: any) {
  return await wrapPage({
    locale,
    fetchProps: async (languageId: string) => {
      const contents = await fetchBasketPageData({
        query: basketPageDataQuery,
        languageId,
      })
      return {
        contents,
      }
    },
    other: {
      revalidate: 5,
    },
  })
}
